$(document).ready(function() {
    loadCurrentDiscounts();
  // Use jQuery to bind the click event
  $(document).on('click', '.discount-toggler', function(e) {
    console.log("clicked");
    $('.custom-discount-form').toggleClass('show');
  });
});



    $(document).on('click', '.apply-discount-button', async function(e) {
  e.preventDefault();
  console.log("applying");
    
    const code = document.getElementById('discount-code-input').value.trim();
    const successMessage = document.getElementById('discount-code-success');
    const errorMessage = document.getElementById('discount-code-error');
    const button = document.querySelector('.apply-discount-button');
    const originalText = button.innerHTML;

    // Reset messages
    errorMessage.style.display = 'none';
    successMessage.style.display = 'none';

    if (!code) {
      errorMessage.textContent = 'Please enter a discount code.';
      errorMessage.style.display = 'block';
      return;
    }

    // Show loading state
    //button.disabled = true;
    button.innerHTML = 'Applying...';

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          discount: code
        })
      });

      const data = await response.json();

      if (response.ok) {
        const discountCode = data.discount_codes?.find(dc => dc.code === code);
        
        if (discountCode && discountCode.applicable) {
          successMessage.textContent = `Discount "${code}" applied successfully!`;
          successMessage.style.display = 'block';
          
            document.getElementById('discount-code-input').value = '';

           document.dispatchEvent(new CustomEvent('cart:refresh', {
                detail: { discount: code }
           }));
          
         updateCartDisplay(data);
         loadCurrentDiscounts();
   
          
        } else {
          const reason = getDiscountNotApplicableReason(discountCode, data);
          errorMessage.textContent = `Discount code cannot be applied: ${reason}`;
          errorMessage.style.display = 'block';
        }
      } else {
        errorMessage.textContent = data.message || `Failed to apply discount: ${data.description || 'Invalid code'}`;
        errorMessage.style.display = 'block';
      }
    } catch (error) {
      errorMessage.textContent = 'Network error. Please try again.';
      errorMessage.style.display = 'block';
      console.error('Error applying discount:', error);
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
  });

  // Function to load and display current applied discounts
  async function loadCurrentDiscounts() {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cartData = await response.json();
      console.log("update discount ui")
      
      displayAppliedDiscounts(cartData.discount_codes,cartData);
      updateCartDisplay(cartData);
    } catch (error) {
      console.error('Error loading cart data:', error);
    }
  }

  // Function to display applied discounts with remove buttons
  function displayAppliedDiscounts(discountCodes,cartData) {
    const discountsContainer = document.getElementById('applied-discounts');
    const applicableDiscounts = discountCodes?.filter(dc => dc.applicable) || [];
    console.log(applicableDiscounts)
    if (applicableDiscounts.length === 0) {
      discountsContainer.innerHTML = '';
      return;
    }

            const discountAmount = cartData.total_discount || 0;

    
    discountsContainer.innerHTML = applicableDiscounts.map(discount => `
      <div class="applied-discount" style="display: flex; justify-content: space-between; align-items: center; background: #f8f8f8; padding: 8px; margin: 0; border-radius: 4px;">
            <span style="font-size:12px;">✓ ${discount.code} (-${formatMoney(discountAmount)})</span>
        <button type="button" class="remove-discount" data-code="${discount.code}" 
                style="height:30px;line-height:30px;background: #ff4444; color: white; border: none; padding: 2px 8px; border-radius: 3px; cursor: pointer; font-size: 12px;">
          Remove
        </button>
      </div>
    `).join('');
    
    // Add event listeners to remove buttons
    discountsContainer.querySelectorAll('.remove-discount').forEach(button => {
      button.addEventListener('click', function() {
        removeDiscount(this.dataset.code);
      });
    });
  }

  // Function to remove a discount
  async function removeDiscount(code) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          discount: '' // Clear all discounts
        })
      });

      const data = await response.json();
      
      if (response.ok) {
        // Update display
        displayAppliedDiscounts([]);
        updateCartDisplay(data);

        document.dispatchEvent(new CustomEvent('cart:refresh', {
            detail: { discount: '' }
        }));
        
        // Show success message
        const successMessage = document.getElementById('discount-code-success');
        successMessage.textContent = `Discount "${code}" removed successfully!`;
        successMessage.style.display = 'block';

        document.getElementById('discount-form').style.display = "block"

        
        // Hide success message after 3 seconds
        setTimeout(() => {
          successMessage.style.display = 'none';
        }, 3000);
      }
    } catch (error) {
      console.error('Error removing discount:', error);
      const errorMessage = document.getElementById('discount-code-error');
      errorMessage.textContent = 'Error removing discount. Please try again.';
      errorMessage.style.display = 'block';
    }
  }

  // Function to update cart display without page refresh
  function updateCartDisplay(cartData) {
    // Update cart subtotal
    const subtotalElement = document.querySelector('.cart-subtotal, [data-cart-subtotal]');
    if (subtotalElement) {
      subtotalElement.textContent = formatMoney(cartData.total_price);
    }
    console.log(cartData)
    if(cartData.discount_codes.length > 0){
      console.log("hide form")
      const discountForm = document.querySelector('.custom-discount-form');
      discountForm.classList.toggle('show');
      document.getElementById('discount-form').style.display = "none"

    }
    // Update discount amount if any
    const discountElement = document.querySelector('.cart-discount, [data-cart-discount]');
    if (discountElement) {
      if (cartData.total_discount > 0) {
        discountElement.style.display = 'block';
        discountElement.textContent = `-${formatMoney(cartData.total_discount)}`;
        document.querySelector('.discount-form').style.display = "none";
      } else {
        discountElement.style.display = 'none';
      }
    }
    
    // Update total price
    const totalElement = document.querySelector('.cart--total--price');
    if (totalElement) {
      totalElement.textContent = formatMoney(cartData.total_price);
    }
    
    // Update item count
    const countElement = document.querySelector('.cart-count, [data-cart-count]');
    if (countElement) {
      countElement.textContent = cartData.item_count;
    }
  }

  // Helper function to format money (use Shopify's format if available)
  function formatMoney(cents) {
    if (window.Shopify?.currency?.formatMoney) {
      return window.Shopify.currency.formatMoney(cents);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  // Helper function to determine why discount is not applicable
  function getDiscountNotApplicableReason(discountCode, cartData) {
    if (!discountCode) {
      return 'Discount code not found';
    }
    
    if (cartData.total_discount === 0) {
      return 'Discount does not meet requirements';
    }
    
    const existingApplicableDiscounts = cartData.discount_codes?.filter(dc => dc.applicable);
    if (existingApplicableDiscounts && existingApplicableDiscounts.length > 0) {
      return 'Another discount is already applied';
    }
    
    return 'Code not applicable to current cart';
  }

  // Enter key support
  document.getElementById('discount-code-input').addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      document.getElementById('discount-form').dispatchEvent(new Event('submit'));
    }
  });